import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const services = [
  {
    title: "Business Clarity",
    description: "Understanding what is really happening in your business, beyond surface-level numbers."
  },
  {
    title: "Decision Support",
    description: "Breaking down options so you can make informed decisions with confidence."
  },
  {
    title: "Mentoring",
    description: "Working with business owners who want ongoing support and a sounding board."
  }
];

export default function WhatIDoPage() {
  return (
    <div data-testid="what-i-do-page">
      {/* Hero */}
      <section className="py-24 md:py-32" data-testid="what-i-do-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <motion.div 
            className="max-w-3xl"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <div className="flex items-center gap-3 mb-8">
              <div className="accent-bar"></div>
              <p className="text-sm font-bold tracking-[0.2em] uppercase text-[#1565C0]">Services</p>
            </div>
            
            <h1 className="font-['Cabinet_Grotesk',sans-serif] text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter text-[#0D1B2A] leading-[1.1] mb-8" data-testid="what-i-do-heading">
              I do not believe in complicated frameworks.
            </h1>
            <p className="text-xl text-[#3D5A73] leading-relaxed">
              I focus on helping business owners get clear on a few key areas.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Services List */}
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="border-t-2 border-[#E0E7ED]">
            {services.map((service, index) => (
              <motion.div
                key={index}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-12 md:py-16 border-b-2 border-[#E0E7ED] group hover:bg-[#F8FAFC] transition-all px-4 -mx-4"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                data-testid={`service-item-${index}`}
              >
                <div className="md:col-span-1">
                  <span className="text-sm font-bold text-[#1565C0]">{String(index + 1).padStart(2, '0')}</span>
                </div>
                <div className="md:col-span-4">
                  <h2 className="font-['Cabinet_Grotesk',sans-serif] text-2xl md:text-3xl font-bold text-[#0D1B2A] group-hover:text-[#1565C0] transition-colors">
                    {service.title}
                  </h2>
                </div>
                <div className="md:col-span-7">
                  <p className="text-lg text-[#3D5A73] leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 md:py-40 bg-[#0D1B2A] relative overflow-hidden" data-testid="what-i-do-cta">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#1565C0]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-[#00897B]/10 rounded-full blur-3xl" />
        
        <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <motion.div 
              className="lg:col-span-8"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <div className="accent-bar mb-8"></div>
              <h2 className="font-['Cabinet_Grotesk',sans-serif] text-4xl md:text-5xl font-bold text-white tracking-tight mb-6" data-testid="what-i-do-cta-heading">
                Not sure where to start?
              </h2>
              <p className="text-xl text-[#90A4AE] leading-relaxed">
                Let's have a conversation about your business and see if I can help.
              </p>
            </motion.div>
            <motion.div 
              className="lg:col-span-4 lg:text-right"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <a
                href="mailto:arorasukhvinder@outlook.com"
                className="btn-premium inline-flex items-center justify-center px-10 py-5 text-sm font-bold tracking-wide bg-[#00897B] text-white hover:bg-[#00796B] transition-all shadow-lg shadow-[#00897B]/25"
                data-testid="what-i-do-cta-button"
              >
                Get in touch <ArrowRight size={16} weight="bold" className="ml-2" />
              </a>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
